import Organisation from '../Models/Organisation';
import DataGridRequest from './DataGridRequest';
export class AllCountriesRequest extends DataGridRequest<Organisation> {
    Url = '/countries/api';
}
